import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { locale } from '../../common/localization/localizationService';

export interface IRouteAdminFilterMenu {
  isRegionFilteringActive: boolean;
  isAgrementFilteringActive: boolean;
  hideRouteStopsWithoutAgreement: () => void;
  changeRegionFilteringState: () => void;
}

export default function RouteAdminFilterMenu(
  props: IRouteAdminFilterMenu
): JSX.Element {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const exceptionClassnames = [
    'filter-menu',
    'filter-menu-element',
    'svg-inline--fa fa-filter fa-w-16',
  ];

  const closeMenu = (event: any): void => {
    const target = event.target as HTMLElement;

    // If the clicked element or any of its parents has an exception class, do not close the menu
    const isException = exceptionClassnames.some((className) =>
      target.closest(`.${className}`)
    );

    if (!isException) {
      setTimeout(() => {
        setMenuOpen(false);
      }, 50);
    }
  };

  useEffect(() => {
    const appElement = document.getElementById('app');
    appElement?.addEventListener('click', closeMenu);

    return () => {
      appElement?.removeEventListener('click', closeMenu);
    };
  }, []);

  return (
    <>
      <div
        className="filter-menu btn btn-outline-dark route-header-action"
        onClick={() => setMenuOpen(!isMenuOpen)}
      >
        <FontAwesomeIcon icon={faFilter} />
      </div>
      {isMenuOpen && (
        <div className="menu-dropdown route-admin-filter-menu">
          <button
            onClick={() => props.hideRouteStopsWithoutAgreement()}
            className={`filter-menu-element ${
              props.isAgrementFilteringActive ? 'selected' : ''
            }`}
          >
            {locale.routeAdminPage._hideWithoutAgreement}
          </button>
          <button
            onClick={() => props.changeRegionFilteringState()}
            className={`filter-menu-element ${
              props.isRegionFilteringActive ? 'selected' : ''
            }`}
          >
            {locale.routeAdminPage._withoutPosition}
          </button>
        </div>
      )}
    </>
  );
}
